import { createLucideIcon } from "lucide-react";

export const Upload = createLucideIcon(
    "Upload",
    [
        [
            "path",
            {
                d: "M12 5C11.2998 5 9.9915 6.9943 9.5 7.5",
                key: "nc9igh",
            },
        ],
        [
            "path",
            {
                d: "M12 5C12.7002 5 14.0085 6.9943 14.5 7.5",
                key: "ehowlw",
            },
        ],
        [
            "path",
            {
                d: "M12 5L12 15",
                key: "1wk532",
            },
        ],
        [
            "path",
            {
                d: "M5 19H19.0001",
                key: "1xegvc",
            },
        ],
    ],
);
